import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup'
import { v4 as uuid } from "uuid"
import "../index.css"

// Inputs
import { TextInputField, AutoCompleteField, Button, ChipsField, TextAreaField, CheckboxField } from '../../../helpers';
import { TabView, TabPanel } from 'primereact/tabview';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';


// ValidationSchema
import { MaterialItemValidation } from '../../../validation/requestMaterialItemValidation'

// utils
import { validateInputs, trimmedInputValues, sortArrayOfObjectsInAlphabeticalOrder, getFullName, convertURLToDataURI, capitalizeWordsInValue } from '../../../utils'

// components
import MaterialMasterInterim from "./materialMasterInterim";

// redux
import { fetchMaterialProductsByCategoryId, fetchMaterialProductsUOMsByCategoryId } from '../../../services/redux/reducers/materialMaster/materialMaster';
import { updateMaterialMasterTempData } from '../../../services/redux/reducers/materialMaster/materialMasterTemp'
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { deleteMaterialMasterTempByMaterialId, getProcessingMaterialImagesUsingParser } from "../../../services/api/materialMasterTemp";
import { materialItemInitialState } from "../../../validation/requestMaterialItemValidation";
import Loading from "../../../common/Loading"
import { sendMessageOnGoogleChat, getGoogleUserChatUri } from "../../../services/api/googleChat";
import { ConfirmDialog } from 'primereact/confirmdialog';
import ProcessingImages from "./ProcessingImages";
import { getTopMatchMaterialSpecificationUsingParser } from "../../../services/api/materialMaster";

const EditPendingMaterialItem = (props) => {
    const dispatch = useDispatch()

    const { materialItemTempObj, materialItemInterimObj, buyerReqAndPOMaterialIds, materialItemObj } = props

    // state
    const [defaultMaterialItemTemp, setDefaultMaterialItemTemp] = useState(false)
    const [isVariantProductUOM, setIsVariantProductUOM] = useState(true)
    const [materialImages, setMaterialImages] = useState([])
    const [imageURL, setImageURL] = useState('')
    const [materialSpecificationMappedProducts, setMaterialSpecificationMappedProducts] = useState([])
    const [isStructuredMaterialItem, setIsStructuredMaterialItem] = useState(false)
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)
    const [visibleRejectMaterialItem, setVisibleRejectMaterialItem] = useState(false)
    const [visibleProcessingImages, setVisibleProcessingImages] = useState(false)
    const [productDescription, setProductDescription] = useState("")
    const [thumbnailImageId, setThumbnailImageId] = useState(null)
    const [prevProductDescription, setPrevProductDescription] = useState("")
    const [showProductDescriptionInput, setShowProductDescriptionInput] = useState(false)
    const [showPrevProductDescriptionInput, setShowPrevProductDescriptionInput] = useState(false)
    const [disabledAskJaadu, setDisabledAskJaadu] = useState(false)
    const [topMatchSpecifications, setTopMatchSpecifications] = useState([])
    const [rejectionRemarks, setRejectionRemarks] = useState("")

    // suggestions state
    const [searchedMaterialCategory, setSearchedMaterialCategory] = useState([])
    const [searchedmaterialBrands, setSearchedmaterialBrands] = useState([])
    const [searchedmaterialUOMs, setSearchedmaterialUOMs] = useState([])
    const [searchedProductNames, setSearchedProductNames] = useState([])
    const [searchedVariantNames, setSearchedVariantNames] = useState([])
    const [searchedMaterialSpecifications, setSearchedMaterialSpecifications] = useState([])

    const isProductsByCaterogyLoading = useSelector(state => state.materialMaster.isProductsByCaterogyLoading)
    const materialMasterTempData = useSelector(state => state.materialMasterTemp.materialMasterTempData)
    const userId = useSelector((state) => state.userDetails.userId)
    
    // form errors state
    const [formErrors, setFormErrors] = useState([]);
    
    useEffect(() => {
        const fetchMaterialImages = async () => {
            if (materialItemTempObj.materialImage && materialItemTempObj.materialImage.length > 0) {
                const formattedMaterialImages = await Promise.all(materialItemTempObj.materialImage.map(async eachImage => ({
                    file: null,
                    fileName: "MATERIAL_MASTER",
                    url: eachImage,
                    dataURI: await convertURLToDataURI(eachImage),
                    documentName: "MATERIAL_MASTER",
                    isOld: true,
                    imageId: uuid()
                })))
    
                setMaterialImages(prevState => [...prevState, ...formattedMaterialImages])
            }
        }
    
        fetchMaterialImages()
    }, [materialItemTempObj])

    const handleSubmitMaterialItemInterim = async () => {
        let { materialItemAllInputValidation, validationData } = await constructMaterialItemValidationData()
        setIsLoaderVisible(true)
        const validationResponse = await validateInputs(materialItemAllInputValidation, validationData)
        console.log("validation-Response", validationResponse)
        setIsLoaderVisible(false)
        if (validationResponse) {
            if (validationResponse.error) {
                setFormErrors(validationResponse.error)
            }
            else {
                if (!materialItemObj?.materialId) {
                    if (materialImages.length === 0 && (!productDescription || !productDescription.trim())) {
                        return dispatch(raiseToast({ severity: 'error', detail: "Please click on Ask Jadu to get images and product description", life: 3000 }))
                    }

                    if (materialImages.length) {
                        if (materialImages.length > 5) {
                            return dispatch(raiseToast({ severity: 'error', detail: "Maximum 5 images should upload", life: 3000 }))
                        }
                        if (!thumbnailImageId) {
                            return dispatch(raiseToast({ severity: 'error', detail: "Please select thumbnail image", life: 3000 }))
                        }
                    } else {
                        return dispatch(raiseToast({ severity: 'error', detail: "Please upload atleast one image", life: 3000 }))
                    }

                    if (!productDescription || !productDescription.trim()) {
                        return dispatch(raiseToast({ severity: 'error', detail: "Please enter product description", life: 3000 }))
                    } else if (productDescription.length < 100) {
                        return dispatch(raiseToast({ severity: 'error', detail: "Product description must be at least 100 characters long", life: 3000 }))
                    } else if (productDescription.length > 500) {
                        return dispatch(raiseToast({ severity: 'error', detail: "Product description cannot exceed 500 characters", life: 3000 }))
                    } else {

                    }
                }

                if(buyerReqAndPOMaterialIds.includes(materialItemObj?.materialId)){
                    return dispatch(raiseToast({severity:'error', detail: `The material is found to be duplicate of material Id: ${materialItemObj.materialId} in same requirement. Please change specs of either material first to proceed.` , life: 3000}))
                }
                setFormErrors({})
                props.onSubmitMaterialItemInterimData(validationResponse.result, materialItemTempObj, buyerReqAndPOMaterialIds)
            }
        }
    }

    const constructMaterialItemValidationData = async () => {
        let validationData = {
            "brandId": materialItemInterimObj?.brandId?.brandId,
            "categoryId": materialItemInterimObj?.categoryId?.categoryId,
            "UOMValue": materialItemInterimObj.UOMValue,
            "keywords": materialItemInterimObj.keywords,
            "remarks": materialItemInterimObj.remarks,
            "materialImages": materialImages,
            "partialSpecsOnly": materialItemInterimObj.partialSpecsOnly,
            "thumbnailImageId": thumbnailImageId,
            "productDescription": productDescription?.trim() ? productDescription : null
        }

        if (materialItemInterimObj?.productName && typeof (materialItemInterimObj?.productName) === 'object') {
            validationData["productName"] = materialItemInterimObj.productName.productName
        } else {
            validationData["productName"] = materialItemInterimObj.productName
        }

        if (materialItemInterimObj?.variantName && typeof (materialItemInterimObj?.variantName) === 'object') {
            validationData["variantName"] = materialItemInterimObj?.variantName?.variantName
        } else {
            validationData["variantName"] = materialItemInterimObj.variantName
        }

        if (materialItemInterimObj?.UOM && typeof (materialItemInterimObj?.UOM) === 'object') {
            validationData["UOM"] = materialItemInterimObj?.UOM?.UOM
        } else {
            validationData["UOM"] = materialItemInterimObj.UOM
        }

        let dynamicInputValidationSchema = {}
        if (props.materialSpecificationAttributes.length > 0) {
            props.materialSpecificationAttributes.forEach((attribute) => {
                validationData[attribute.name] = materialItemInterimObj[attribute.name]
                dynamicInputValidationSchema[attribute.name] = yup.string()
                    .transform((value) => trimmedInputValues(value))
                    .test('specificationAttribute-validation', `Please enter ${attribute.name}`, value => {
                        if (attribute.mandatory === 1 && !value) {
                            return false
                        }
                        return true
                    })
                    .nullable()
            })
        }
        else {

            if (typeof (materialItemInterimObj.productSpecification) === 'object') {
                validationData["productSpecification"] = materialItemInterimObj?.productSpecification?.productSpecification
            } else {
                validationData["productSpecification"] = materialItemInterimObj?.productSpecification
            }

            dynamicInputValidationSchema["productSpecification"] = yup.string()
                .required("Please enter product specification")
                .transform((value) => trimmedInputValues(value))
                .test('specificationLength', 'Specification should be more than 3 characters', value => value.length > 2)
        }

        let materialItemAllInputValidation = MaterialItemValidation.concat(yup.object().shape(dynamicInputValidationSchema));
        return { materialItemAllInputValidation, validationData }
    }

    const handleKeyPress = (e) => {
        const input = e.target.value;
        const regex = /^[A-Z0-9 ]+$/i
    
        if (e.target.name === "variantName" && e.key === '.') {
            if (input !== 'NA' || input.includes('.')) {
                e.preventDefault()
            }
        } else if (e.target.name === "variantName" && input.includes('.')) {
            e.preventDefault()
        } else if (!regex.test(e.key)) {
            e.preventDefault()
        }
    }

    const handleCopyPaste = (e) => {
        e.preventDefault()
    }

    const handleDragOver = (e) => {
        e.preventDefault();
    }

    const handleDrop = (e) => {
        e.preventDefault();
    }

    const arraysOfObjectsAreEqual = (materialItemInterimSpecArr, relatedMaterialItemSpecArr) => {
        
        if (materialItemInterimSpecArr?.length !== relatedMaterialItemSpecArr?.length) {
            return false;
        }

        materialItemInterimSpecArr.sort((a, b) => {
            return a.id - b.id;
        });

        relatedMaterialItemSpecArr.sort((a, b) => {
            return a.id - b.id;
        });

        for (let i = 0; i < materialItemInterimSpecArr.length; i++) {
            if (!objectsAreEqual(materialItemInterimSpecArr[i], relatedMaterialItemSpecArr[i])) {
                return false;
            }
        }

        return true;
    }

    const objectsAreEqual = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    }

    const onBlurSpecificationChange = (event) => {

        let productSpecification = ''
        let relatedMaterialSpecification = null
        if (typeof (event.target.value) === "object") {
            productSpecification = event.target.value.productSpecification?.trim()?.toLowerCase()
            relatedMaterialSpecification = props.materialSpecification.find(specification => specification.productSpecification?.toLowerCase() === event.target.value?.productSpecification?.trim()?.toLowerCase())
        }
        else {
            productSpecification = event.target.value?.trim()?.toLowerCase()
            relatedMaterialSpecification = props.materialSpecification.find(specification => specification.productSpecification?.toLowerCase() === event.target.value?.trim()?.toLowerCase())
        }
        if (!relatedMaterialSpecification) {
            let relatedProductSpecifications = []
            if (typeof (materialItemInterimObj['variantName']) === "object") {
                relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj['variantName'].variantName?.trim()?.toLowerCase())
            }
            else {
                relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj['variantName']?.trim()?.toLowerCase())
            }

            let relatedMaterialSpecificationSOPs = relatedProductSpecifications.filter(specification => specification.materialSpecificationId)

            if (relatedMaterialSpecificationSOPs.length > 0) {
                materialItemInterimObj["productSpecification"] = ""
                props.setMaterialItemInterimObj({ ...materialItemInterimObj })
            }
        }
    }

    const onBlurVariantChange = (event) => {
        if (event.relatedTarget && event.relatedTarget.classList.contains('p-virtualscroller')) {
            return
        }
        if(event.target.value && event.target.value.trim()){
            getTopMatchMaterialSpecifications()
        }
    }

    const handleInputChange = (event) => {
        if (typeof (event.target.value) === "object") {
            materialItemInterimObj[event.target.name] = event.target.value
        }
        else {
            if (event.target.name === 'remarks' || event.target.name === "categoryId" || event.target.name === "brandId") {
                materialItemInterimObj[event.target.name] = event.target.value
            } else if(event.target.name === 'partialSpecsOnly'){
                materialItemInterimObj[event.target.name] = event.checked
                if(event.checked){
                    props.setMaterialSpecification([])
                    props.setMaterialSpecificationAttributes([])
                    materialItemInterimObj.productSpecification = materialItemTempObj.productSpecification
                }else{
                    materialItemInterimObj.productSpecification = ""
                }
            }else {
                materialItemInterimObj[event.target.name] = event.target.value?.toUpperCase()
            }
        }
        
        if (event.target.value != null) {

            if (event.target.name === "categoryId") {

                materialItemInterimObj["productName"] = ""
                materialItemInterimObj["variantName"] = ""
                materialItemInterimObj["UOM"] = ""
                materialItemInterimObj["UOMValue"] = ""
                materialItemInterimObj['keywords'] = []

                if(!materialItemInterimObj.partialSpecsOnly){
                    materialItemInterimObj["productSpecification"] = ""
                }

                if (typeof (event.target.value) === "object") {
                    dispatch(fetchMaterialProductsByCategoryId(event.target.value.categoryId))
                    dispatch(fetchMaterialProductsUOMsByCategoryId(event.target.value.categoryId))
                } else {
                    const relatedCategory = props.materialCategory.find(category => category.categoryName.toLowerCase() === event.target.value?.trim().toLowerCase())
                    if (relatedCategory) {
                        materialItemInterimObj[event.target.name] = relatedCategory
                        dispatch(fetchMaterialProductsByCategoryId(relatedCategory.categoryId))
                        dispatch(fetchMaterialProductsUOMsByCategoryId(relatedCategory.categoryId))
                    }
                }

                props.setMaterialSpecification([])
                props.setMaterialSpecificationAttributes([])
            }
            if (event.target.name === "brandId") {
                if (typeof (event.target.value) !== "object") {
                    const relatedBrand = props.materialBrands.find(brand => brand.brandName.toLowerCase() === event.target.value?.trim().toLowerCase())
                    if (relatedBrand) {
                        materialItemInterimObj[event.target.name] = relatedBrand
                    }
                }
            }
            if (event.target.name === "productName") {

                let relatedVariantNames = []
                let relatedMaterialSpecsVariantNames = []
                if (typeof (event.target.value) === "object") {
                    relatedVariantNames = props.materialProductsByCaterogy.filter(product => product?.productName.toLowerCase() === event.target.value.productName?.trim()?.toLowerCase())
                    let relatedMaterialSpecificationsMappingProducts = props.materialProductsByCaterogy.filter(product => product.materialSpecificationId && product?.productName.toLowerCase() === event.target.value.productName?.trim()?.toLowerCase())
                    if (relatedMaterialSpecificationsMappingProducts.length > 0) {
                        relatedMaterialSpecsVariantNames = relatedMaterialSpecificationsMappingProducts
                        let sortedMaterialSpecsVariantNames = sortArrayOfObjectsInAlphabeticalOrder(relatedMaterialSpecsVariantNames, "variantName")
                        setMaterialSpecificationMappedProducts([...sortedMaterialSpecsVariantNames])

                    } else {
                        setMaterialSpecificationMappedProducts([])
                    }
                }
                else {
                    relatedVariantNames = props.materialProductsByCaterogy.filter(product => product?.productName.toLowerCase() === event.target.value?.trim().toLowerCase())
                    let relatedMaterialSpecificationsMappingProducts = props.materialProductsByCaterogy.filter(product => product.materialSpecificationId && product?.productName.toLowerCase() === event.target.value?.trim()?.toLowerCase())
                    if (relatedMaterialSpecificationsMappingProducts.length > 0) {
                        relatedMaterialSpecsVariantNames = relatedMaterialSpecificationsMappingProducts
                        let sortedMaterialSpecsVariantNames = sortArrayOfObjectsInAlphabeticalOrder(relatedMaterialSpecsVariantNames, "variantName")
                        setMaterialSpecificationMappedProducts([...sortedMaterialSpecsVariantNames])
                    } else {
                        setMaterialSpecificationMappedProducts([])
                    }

                    const relatedVariantName = props.materialProductsByCaterogy.find(product => product?.productName.toLowerCase() === event.target.value?.trim().toLowerCase())
                    if (relatedVariantName) {
                        materialItemInterimObj[event.target.name] = relatedVariantName.productName
                    }
                }

                let sortedVariantNames = sortArrayOfObjectsInAlphabeticalOrder(relatedVariantNames, "variantName")

                props.setMaterialVariantProducts(sortedVariantNames)
                props.setMaterialSpecification([])

                const relatedMaterialProductUOM = props.materialProductsUOMsByCaterogy?.find(product => {
                    let productName = ""
                    let variantName = ""
                    if (typeof (materialItemInterimObj.productName) === "object") {
                        productName = materialItemInterimObj.productName.productName?.trim()?.toLowerCase()
                    }
                    else {
                        productName = materialItemInterimObj.productName?.trim()?.toLowerCase()
                    }

                    if (typeof (materialItemInterimObj.variantName) === "object") {
                        variantName = materialItemInterimObj.variantName.variantName?.trim()?.toLowerCase()
                    }
                    else {
                        variantName = materialItemInterimObj.variantName?.trim()?.toLowerCase()
                    }

                    if (product.productName.toLowerCase() === productName && product.variantName.toLowerCase() === variantName) {
                        return true
                    }
                })

                materialItemInterimObj["variantName"] = ""
                materialItemInterimObj["UOMValue"] = ""

                if(!materialItemInterimObj.partialSpecsOnly){
                    materialItemInterimObj["productSpecification"] = ""
                }

                if (relatedMaterialProductUOM) {
                    materialItemInterimObj["UOM"] = relatedMaterialProductUOM.UOM
                    setIsVariantProductUOM(true)
                } else {
                    materialItemInterimObj["UOM"] = ''
                    setIsVariantProductUOM(false)
                }

                props.setMaterialSpecification([])
                props.setMaterialSpecificationAttributes([])
            }

            if ((event.target.name === "variantName" && !materialItemInterimObj.partialSpecsOnly) || (event.target.name === "partialSpecsOnly" && materialItemInterimObj.variantName && !materialItemInterimObj.partialSpecsOnly)) {
                let relatedProductSpecifications = []
                if (typeof (materialItemInterimObj.variantName) === "object") {
                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj.variantName?.variantName?.trim()?.toLowerCase())
                }
                else {

                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj.variantName?.trim()?.toLowerCase())
                    const relatedProductSpecification = props.materialVariantProducts.find(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj.variantName?.trim()?.toLowerCase())
                    if (relatedProductSpecification) {
                        materialItemInterimObj["variantName"] = relatedProductSpecification.variantName
                    }
                }

                let relatedMaterialSpecificationSOPs = relatedProductSpecifications.filter(specification => specification.materialSpecificationId)
                let sortedMaterialSpecificationSOPs = sortArrayOfObjectsInAlphabeticalOrder(relatedMaterialSpecificationSOPs, "attribute")

                let relatedSpecifications = []
                if(sortedMaterialSpecificationSOPs.length > 0){
                    materialItemInterimObj["isStructuredProduct"] = true
                    relatedSpecifications = relatedProductSpecifications.filter(specification => !specification.materialSpecificationId && !buyerReqAndPOMaterialIds.includes(specification?.materialId) && specification.productSpecificationJSON)
                }else{
                    materialItemInterimObj["isStructuredProduct"] = false
                    relatedSpecifications = relatedProductSpecifications.filter(specification => !specification.materialSpecificationId && !buyerReqAndPOMaterialIds.includes(specification?.materialId) && !specification.productSpecificationJSON)
                }

                if (relatedSpecifications?.length > 0 && (props.materialSpecificationAttributes?.length === 0  || props.materialSpecificationAttributes?.length > 0)) {
                    let sortedProductSpecifications = sortArrayOfObjectsInAlphabeticalOrder(relatedSpecifications, "productSpecification")
                    props.setMaterialSpecification([...sortedProductSpecifications])
                    props.setMaterialSpecificationAttributes([])
                    if(materialItemInterimObj?.currentProdSpecification){
                        delete materialItemInterimObj.currentProdSpecification
                    }
                    if(!materialItemInterimObj.partialSpecsOnly){
                        materialItemInterimObj["productSpecification"] = ""
                    }
                }
                else {
                    if (sortedMaterialSpecificationSOPs.length > 0) {
                        let specificationAttributes = []
                        sortedMaterialSpecificationSOPs.map(specification => {
                            let attributeObj = {
                                name: specification.attribute,
                                mandatory: specification.materialSpecificationMandatoryTypeId,
                                unit: specification.attributeUnit
                            }
                            specificationAttributes.push(attributeObj)
                        })
                        
                        props.setMaterialSpecificationAttributes(specificationAttributes)
                        props.setMaterialSpecification([...sortedMaterialSpecificationSOPs])
                    }
                    else {
                        props.setMaterialSpecificationAttributes([])
                        props.setMaterialSpecification([...relatedSpecifications])
                    }
                }

                const relatedMaterialProductUOM = props.materialProductsUOMsByCaterogy?.find(product => {
                    let productName = ""
                    let variantName = ""
                    if (typeof (materialItemInterimObj.productName) === "object") {
                        productName = materialItemInterimObj.productName.productName?.trim()?.toLowerCase()
                    }
                    else {
                        productName = materialItemInterimObj.productName?.trim()?.toLowerCase()
                    }

                    if (typeof (materialItemInterimObj.variantName) === "object") {
                        variantName = materialItemInterimObj.variantName.variantName?.trim()?.toLowerCase()
                    }
                    else {
                        variantName = materialItemInterimObj.variantName?.trim()?.toLowerCase()
                    }

                    if (product.productName.toLowerCase() === productName && product.variantName.toLowerCase() === variantName) {
                        return true
                    }
                })

                if (relatedMaterialProductUOM) {
                    materialItemInterimObj["UOM"] = relatedMaterialProductUOM.UOM
                    setIsVariantProductUOM(true)
                } else{
                    setIsVariantProductUOM(false)
                }
            }

            if (event.target.name === "productSpecification") {
                let productSpecification = ''
                let relatedMaterialSpecification = null
                if (typeof (event.target.value) === "object") {
                    productSpecification = event.target.value.productSpecification?.trim()?.toLowerCase()
                    relatedMaterialSpecification = props.materialSpecification.find(specification => specification.productSpecification?.toLowerCase() === event.target.value?.productSpecification?.trim()?.toLowerCase())
                }
                else {
                    productSpecification = event.target.value?.trim()?.toLowerCase()
                    relatedMaterialSpecification = props.materialSpecification.find(specification => specification.productSpecification?.toLowerCase() === event.target.value?.trim()?.toLowerCase())
                }
                
                if (relatedMaterialSpecification) {
                    materialItemInterimObj["UOM"] = relatedMaterialSpecification.UOM
                    materialItemInterimObj["UOMValue"] = relatedMaterialSpecification.UOMValue
                    setIsVariantProductUOM(true)
                } else {
                    materialItemInterimObj["UOM"] = ''
                    materialItemInterimObj["UOMValue"] = ''
                    setIsVariantProductUOM(false)
                }

                let relatedProductSpecifications = []

                if (typeof (materialItemInterimObj['variantName']) === "object") {
                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj['variantName'].variantName?.trim()?.toLowerCase())
                }
                else {
                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj['variantName']?.trim()?.toLowerCase())
                }

                let relatedMaterialSpecificationSOPs = relatedProductSpecifications.filter(specification => specification.materialSpecificationId)
                let sortedMaterialSpecificationSOPs = sortArrayOfObjectsInAlphabeticalOrder(relatedMaterialSpecificationSOPs, "attribute")

                if (productSpecification === "Specs do not exist, enter new specs..".toLowerCase() || (sortedMaterialSpecificationSOPs.length > 0 && relatedMaterialSpecification)) {
                    if (sortedMaterialSpecificationSOPs.length > 0) {
                        let specificationAttributes = []
                        sortedMaterialSpecificationSOPs.map(specification => {
                            let attributeObj = {
                                name: specification.attribute,
                                mandatory: specification.materialSpecificationMandatoryTypeId,
                            }

                            if (specification.attributeUnit) {
                                attributeObj.unit = specification.attributeUnit
                            }

                            specificationAttributes.push(attributeObj)
                        })
                        props.setMaterialSpecificationAttributes(specificationAttributes)
                        props.setMaterialSpecification([...sortedMaterialSpecificationSOPs])
                    }
                    else {
                        props.setMaterialSpecificationAttributes([])
                    }
                    
                    if (relatedMaterialSpecification?.productSpecificationJSON && sortedMaterialSpecificationSOPs) {
                        let specificationJSON = relatedMaterialSpecification.productSpecificationJSON.map(jsonString => JSON.parse(jsonString))
                        specificationJSON.forEach(spec => {
                            materialItemInterimObj[spec.type] = spec.value
                        })
                        materialItemInterimObj["currentProdSpecification"] = typeof (event.target.value) === "object" ? event.target.value.productSpecification : event.target.value
                    }else{
                        materialItemInterimObj["currentProdSpecification"] = ""
                    }
                }
            }
        }

        props.setMaterialItemInterimObj({ ...materialItemInterimObj })

        if (materialItemInterimObj['categoryId'] && materialItemInterimObj['brandId'] && materialItemInterimObj['productName'] && materialItemInterimObj['variantName'] && materialItemInterimObj['UOM'] && materialItemInterimObj['UOMValue']) {
            let relatedProductSpecifications = []
            if (typeof (materialItemInterimObj['variantName']) === "object") {
                relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj['variantName'].variantName?.trim()?.toLowerCase())
            }
            else {
                relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj['variantName']?.trim()?.toLowerCase())
            }

            relatedProductSpecifications.sort((specsA, specsB) => {
                return specsA.materialId - specsB.materialId
            })

            let relatedSpecifications = relatedProductSpecifications.find(product => {
                if (product.categoryId === materialItemInterimObj['categoryId']?.categoryId &&
                    product.brandId === materialItemInterimObj['brandId']?.brandId &&
                    product.productName?.toLowerCase() === (typeof (materialItemInterimObj['productName']) === "object" ? materialItemInterimObj['productName'].productName?.toLowerCase() : materialItemInterimObj['productName']?.toLowerCase()) &&
                    product.variantName?.toLowerCase() === (typeof (materialItemInterimObj['variantName']) === "object" ? materialItemInterimObj['variantName']?.variantName?.toLowerCase() : materialItemInterimObj['variantName']?.toLowerCase()) &&
                    product.UOM?.toLowerCase() === (typeof (materialItemInterimObj['UOM']) === "object" ? materialItemInterimObj['UOM']?.UOM?.toLowerCase() : materialItemInterimObj['UOM']?.toLowerCase()) &&
                    product.UOMValue === materialItemInterimObj['UOMValue']
                ) {
                    let specificationAttributesWithValues = []
                    if (props.materialSpecificationAttributes.length > 0) {
                        props.materialSpecificationAttributes.map((attribute) => {
                            const attributeObj = {
                                type: attribute.name,
                                value: materialItemInterimObj[attribute.name] ? materialItemInterimObj[attribute.name].trim() : null,
                            }

                            if (attribute.unit) {
                                attributeObj.unit = attribute.unit
                            }

                            specificationAttributesWithValues.push(JSON.stringify(attributeObj))
                        })
                    }

                    if (specificationAttributesWithValues.length > 0) {
                        let productSpecificationJSON = JSON.parse(JSON.stringify(product.productSpecificationJSON))
                        if (arraysOfObjectsAreEqual(specificationAttributesWithValues, productSpecificationJSON)) {
                            return true
                        }
                    }
                    else {
                        return product.productSpecification?.toLowerCase() === (typeof (materialItemInterimObj['productSpecification']) === "object" ? materialItemInterimObj['productSpecification']?.productSpecification?.toLowerCase() : materialItemInterimObj['productSpecification']?.toLowerCase())
                    }
                }
            })

            if (relatedSpecifications) {
                props.setMaterialItemObj({ ...relatedSpecifications })
            } else {
                props.setMaterialItemObj({})
            }
        }
        else {
            props.setMaterialItemObj({})
        }
    }

    const searchCategory = (event) => {
        const relatedCategory = props.materialCategory.filter(category => category.categoryName.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedMaterialCategory([...relatedCategory])
    }

    const searchBrands = (event) => {
        const relatedBrand = props.materialBrands.filter(brand => brand.brandName.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialBrands([...relatedBrand])
    }

    const searchUOMs = (event) => {
        const relatedUOMs = props.materialUOMData.filter(materialUOM => materialUOM.UOM.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialUOMs([...relatedUOMs])
    }

    const searchProductNames = (event) => {
        let productNames = []
        const relatedProductNames = props.materialProductsByCaterogy.filter(product => {
            if (product.productName?.toLowerCase().includes(event.query.trim()?.toLowerCase())) {
                if (!productNames.includes(product.productName?.toLowerCase())) {
                    productNames.push(product.productName?.toLowerCase())
                    return true
                }
            }
        })

        setSearchedProductNames([...relatedProductNames])
    }

    const searchVariantNames = (event) => {
        let variantNames = []
        let relatedVariantNames = []
        if(materialSpecificationMappedProducts?.length > 0){
            relatedVariantNames = materialSpecificationMappedProducts?.filter(product => {
                if (product.variantName?.toLowerCase().includes(event.query.trim()?.toLowerCase())) {
                    if (!variantNames.includes(product.variantName?.toLowerCase())) {
                        variantNames.push(product.variantName?.toLowerCase())
                        return true
                    }
                }
            })
        }else{
            relatedVariantNames = props.materialVariantProducts?.filter(product => {
                if (product.variantName?.toLowerCase().includes(event.query.trim()?.toLowerCase())) {
                    if (!variantNames.includes(product.variantName?.toLowerCase())) {
                        variantNames.push(product.variantName?.toLowerCase())
                        return true
                    }
                }
            })
        }

        setSearchedVariantNames([...relatedVariantNames])
    }

    const getTopMatchMaterialSpecifications = async() => {
        
        let data = {
            category_id: materialItemInterimObj['categoryId']?.categoryId,
            brand_name: materialItemInterimObj['brandId']?.brandName,
            product_name: typeof materialItemInterimObj.productName === "object" ? materialItemInterimObj['productName'].productName : materialItemInterimObj.productName,
            variant_name: typeof materialItemInterimObj.variantName === "object" ? materialItemInterimObj['variantName'].variantName : materialItemInterimObj.variantName,
            specification: materialItemTempObj.productSpecification ? materialItemTempObj.productSpecification : ''
        }
        
        setIsLoaderVisible(true)
        const topMatchSpecificationsRes = await getTopMatchMaterialSpecificationUsingParser(data)
        setIsLoaderVisible(false)
        
        if (topMatchSpecificationsRes.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: topMatchSpecificationsRes.data.error, life: 3000 }))
        } else {
            setTopMatchSpecifications(topMatchSpecificationsRes.data)
        }
    }

    const searchMaterialSpecification = (event) => {
        let relatedMaterialSpecification = []
        let showSpecsDoNotExistText = true
        if(!materialItemInterimObj.productSpecification?.trim() && !event.query.trim() && topMatchSpecifications.length){
            showSpecsDoNotExistText = false
            relatedMaterialSpecification = topMatchSpecifications.filter(specification => specification.productSpecification?.toLowerCase().includes(event.query.trim()?.toLowerCase()) && !buyerReqAndPOMaterialIds.includes(specification?.materialId))
        }else{
            relatedMaterialSpecification = props.materialSpecification.filter(specification => specification.productSpecification?.toLowerCase().includes(event.query.trim()?.toLowerCase()) && !buyerReqAndPOMaterialIds.includes(specification?.materialId))
        }

        let relatedProductSpecifications = []
        if (typeof (materialItemInterimObj["variantName"]) === "object") {
            relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj["variantName"].variantName?.trim()?.toLowerCase())
        }
        else {
            relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === materialItemInterimObj["variantName"]?.trim()?.toLowerCase())
        }

        let relatedMaterialSpecificationSOPs = relatedProductSpecifications.filter(specification => specification.materialSpecificationId)
        if (relatedMaterialSpecificationSOPs.length > 0) {
            setIsStructuredMaterialItem(true)
            if(showSpecsDoNotExistText){
                setSearchedMaterialSpecifications([...relatedMaterialSpecification, { productSpecification: "Specs do not exist, enter new specs.." }])
            }else{
                setSearchedMaterialSpecifications([...relatedMaterialSpecification])
            }
        }
        else {
            setIsStructuredMaterialItem(false)
            setSearchedMaterialSpecifications([...relatedMaterialSpecification])
        }
    }

    const handleSetDefaultMaterialItemTemp = (e) => {
        setDefaultMaterialItemTemp(e.checked)
        if (e.checked) {
            let relatedCategory = props.materialCategory?.find(category => category.categoryId === materialItemTempObj.categoryId)
            let relatedBrand = props.materialBrands?.find(brand => brand.brandId === materialItemTempObj.brandId)
            props.setMaterialItemInterimObj({ ...materialItemTempObj, categoryId: relatedCategory, brandId: relatedBrand })
        }
        else {
            props.setMaterialItemInterimObj({})
        }
    }

    const handleUploadMaterialImage = async ({ files, options }) => {
        const filesArray = Array.from(files);
        // if (files.length > 3 || (materialImages.length + files.length) > 3) {
        //     options.clear()
        //     return dispatch(raiseToast({ severity: 'warn', summary: 'Warning Message', detail: "Maximum upload images should be 3 only", life: 3000 }))
        // }

        // let uploadImages = []
        let uploadImageData = null
        await Promise.all(
            filesArray.map((file) => new Promise((resolve) => {
                if (file.size > 5242880) {
                    options.clear()
                    return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000 }))
                } else {
                    const fileReader = new FileReader()
                    fileReader.onload = (e) => {
                        const dataURI = e.target.result
                        // uploadImages.push({
                        //     url: file.objectURL,
                        //     documentName: "MATERIAL_MASTER",
                        //     fileName: file.name,
                        //     dataURI: dataURI,
                        // });
                        uploadImageData = {
                            fileName: file.name,
                            dataURI: dataURI,
                        }
                        resolve()
                    };

                    fileReader.readAsDataURL(file);
                }
            }))
        )

        // setMaterialImages(prevImages => [...prevImages, ...uploadImages])
        options.clear()
        await handleProcessImageInputType("UPLOAD_IMAGE", uploadImageData)
    }

    const handleImageURLChange = (event) => {
        setImageURL(event.target.value)
    }

    const handleImageUrl = async (imageUrl) => {
        if (imageUrl) {
            imageUrl = imageUrl.trim()
        }

        if (!imageUrl || imageUrl === '') {
            return dispatch(raiseToast({ severity: 'warn', summary: 'Warning Message', detail: "Please enter proper url", life: 3000 }))
        }

        await handleProcessImageInputType("IMAGE_URL", {imageUrl: [imageURL]})
    }

    const handleRemoveMaterialImage = (removedImageId) => {
        const relatedImages = materialImages.filter(image => removedImageId !== image.imageId)
        if(removedImageId === thumbnailImageId){
            setThumbnailImageId(null)
        }
        setMaterialImages([...relatedImages])
    }

    const handleRejectMaterialItem = async(materialId, customMesagge, rejectionRemarks) => {
        let data = {
            remarks: rejectionRemarks
        }
        if (window.confirm("This will send chat message to kam.\nAre you sure you want to reject")) {
            setIsLoaderVisible(true)
            const rejectedMaterialItemResponse = await deleteMaterialMasterTempByMaterialId(materialId, data)
            setIsLoaderVisible(false)
            console.log("rejectedMaterialItemResponse - response", rejectedMaterialItemResponse)
            if (rejectedMaterialItemResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: rejectedMaterialItemResponse.data.error, life: 3000 }))
            } else {
                dispatch(raiseToast({ severity: 'success', detail: "Material item rejected successfully", life: 3000 }))
                if(customMesagge){
                    await handleSendMessageOnGoogleChat(customMesagge)
                }
                const relatedMaterialMasterTempData = materialMasterTempData.filter(eachMaterialItem => eachMaterialItem.materialId !== materialId)
                dispatch(updateMaterialMasterTempData([...relatedMaterialMasterTempData]))
                props.setMaterialItemInterimObj({...materialItemInitialState})
                props.setMaterialSpecificationAttributes([])
                props.setMaterialVariantProducts([])
                props.setMaterialSpecification([])
                props.setMaterialItemObj({})
                setVisibleRejectMaterialItem(false)
                props.setVisibleEditPendingMaterialItem(false)
            }
        }
    }

    const handleCopyClick = (text) => {
        if(text){
            navigator.clipboard.writeText(text)
        }
    }

    const handleCustomMessageType = async(messageType) => {
        
        let trimmedRejectedRemarks = null
        if(["WRONG_CATEGORY", "KAM_REQUEST"].includes(messageType)){
            trimmedRejectedRemarks = rejectionRemarks.trim()
            if(!trimmedRejectedRemarks){
                return dispatch(raiseToast({ severity: 'error', detail: "Please enter rejection remarks", life: 3000 }))
            }
        }

        let text = ""
        switch (messageType) {
            case "PARTIAL_SPECS":
                text = `Shall material ${materialItemTempObj?.materialId} be sent for partial specs approval?`
                handleCopyClick(text)
                handleSendMessageOnGoogleChat(text)
                break
            case "WRONG_CATEGORY":
                text = `Approval for material ${materialItemTempObj?.materialId} has been rejected, because wrong category was assigned.`
                handleCopyClick(text)
                handleRejectMaterialItem(materialItemTempObj.materialId, text, trimmedRejectedRemarks)
                break
            case "KAM_REQUEST":
                text = `Approval for material ${materialItemTempObj?.materialId} has been rejected based on your request.`
                handleCopyClick(text)
                handleRejectMaterialItem(materialItemTempObj.materialId, text, trimmedRejectedRemarks)
                break
            case "MISSING_SPECS":
                let missingAttributes = []
                if (props.materialSpecificationAttributes.length > 0) {
                    props.materialSpecificationAttributes.forEach((attribute) => {
                        if((!materialItemInterimObj[attribute.name] || !materialItemInterimObj[attribute.name]?.trim()) && attribute.mandatory === 1){
                            let missingAttributeText = `${attribute.name}${attribute.unit ? ` (${attribute.unit})` : ""}`
                            missingAttributes.push(missingAttributeText)
                        }
                    })
                }
                
                if(missingAttributes.length > 0){
                    text = `Material ${materialItemTempObj?.materialId}, is missing following mandatory specs. Please provide the same.\n${missingAttributes.join(",\n")}`
                    handleCopyClick(text)
                    handleSendMessageOnGoogleChat(text)
                }
                break
            case "GOOGLE_CHAT":
                handleGetGoogleUserChatUri()
                break
            default:
                text = ""
        }
    }

    const handleSendMessageOnGoogleChat = async(message) => {
        
        let data = {
            userId: userId, 
            emailId: materialItemTempObj.raisedByUserEmail,
            message
        }
        setIsLoaderVisible(true)
        const sendMessageOnGoogleChatRes = await sendMessageOnGoogleChat(data)
        console.log("sendMessageOnGoogleChat-response", sendMessageOnGoogleChatRes)
        setIsLoaderVisible(false)

        if (sendMessageOnGoogleChatRes.failure) {
            if(window.confirm("Chat with the user doesn't exist.\nThe message has been copied.\nPlease open chat manually, and paste the message.")){
                window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank')
            }
        }else{
            window.open(sendMessageOnGoogleChatRes.data, '_blank')
        }
    }

    const handleGetGoogleUserChatUri = async() => {
        
        let data = {
            userId: userId, 
            emailId: materialItemTempObj.raisedByUserEmail
        }
        setIsLoaderVisible(true)
        const getGoogleUserChatUriRes = await getGoogleUserChatUri(data)
        console.log("getGoogleUserChatUri-response", getGoogleUserChatUriRes)
        setIsLoaderVisible(false)

        if (getGoogleUserChatUriRes.failure) {
            if(window.confirm("Chat with the user doesn't exist.\nThe message has been copied.\nPlease open chat manually, and paste the message.")){
                window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank') 
            }
        }else{
            window.open(getGoogleUserChatUriRes.data, '_blank')
        }
    }
    
    let relatedMaterialSpecifications = props.materialSpecification.filter(specification => specification.materialSpecificationId)

    let relatedCategory = props.materialCategory?.find(category => category.categoryId === materialItemTempObj.categoryId)
    let relatedBrand = props.materialBrands?.find(brand => brand.brandId === materialItemTempObj.brandId)

    let allAttributesValid = true
    if (props.materialSpecificationAttributes.length && relatedMaterialSpecifications.length) {
        props.materialSpecificationAttributes.forEach((attribute) => {
            if (attribute.mandatory === 1) {
                const attributeName = attribute.name
                const attributeValue = materialItemInterimObj[attributeName]
                if (!attributeValue || (attributeValue && attributeValue.trim() === '')) {
                    allAttributesValid = false
                }
            }
        })
    }
    
    const handleProcessImageInputType = async (imageType, imageData) => {
        let processImageData = null
        switch (imageType) {
            case "MATERIAL_DETAILS":
                if (materialImages.length) {
                    setVisibleProcessingImages(true)
                } else {
                    let { materialItemAllInputValidation, validationData } = await constructMaterialItemValidationData()
                    const validationResponse = await validateInputs(materialItemAllInputValidation, validationData)
                    console.log("validation-Response", validationResponse, materialItemInterimObj)
                    if (validationResponse) {
                        if (validationResponse.error) {
                            setFormErrors(validationResponse.error)
                        }
                        else {
                            setFormErrors({})

                            let materialItem = { ...validationResponse.result }
                            let specificationAttributesWithValues = []
                            props.materialSpecificationAttributes.map((attribute) => {
                                const attributeObj = {
                                    type: attribute.name,
                                    value: materialItem[attribute.name] ? materialItem[attribute.name] : null,
                                }
                                if (attribute.unit) {
                                    attributeObj.unit = attribute.unit
                                }
                                specificationAttributesWithValues.push(JSON.stringify(attributeObj))
                            })

                            let materialSpecification = []
                            if (props.materialSpecificationAttributes.length > 0) {
                                props.materialSpecificationAttributes.map((attribute) => {
                                    if (materialItem[attribute.name] && materialItem[attribute.name] != "") {
                                        let specificationAttribute = attribute.name + " " + materialItem[attribute.name] + (attribute.unit ? " " + attribute.unit : "")
                                        materialSpecification.push(specificationAttribute)
                                    }
                                })
                            }
                            else {
                                materialSpecification.push(materialItem.productSpecification)
                            }

                            if (materialSpecification.length > 0) {
                                if (materialSpecification.join(", ")?.length < 3) {
                                    return dispatch(raiseToast({ severity: 'warn', detail: "Specification should be more than 3 characters", life: 3000 }))
                                }
                            }

                            processImageData = {
                                "type": imageType,
                                "productName": materialItem.productName,
                                "brandName": materialItemInterimObj.brandId.brandName,
                                "productSpecs": materialSpecification.join(", "),
                                "variant": materialItem.variantName,
                                "categoryName": materialItemInterimObj.categoryId.categoryName
                            }

                            Object.keys(processImageData).forEach(key => {
                                if(key !== "type"){
                                    processImageData[key] = capitalizeWordsInValue(processImageData[key])
                                }
                            })
                        }
                    }
                }
                break
            case "UPLOAD_IMAGE":
                processImageData = {
                    "type": imageType,
                    ...imageData
                }
                break
            case "IMAGE_URL":
                processImageData = {
                    "type": imageType,
                    ...imageData
                }
                break
            default:
                processImageData = null
        }

        if (processImageData) {
            await getProcessingMaterialImages(processImageData)
        }
    }

    const getProcessingMaterialImages = async (processImageData) => {
        setIsLoaderVisible(true)
        let processingMaterialsImageRes = await getProcessingMaterialImagesUsingParser(processImageData)
        console.log("processingMaterialsImage-res", processingMaterialsImageRes)
        setIsLoaderVisible(false)
        if(processingMaterialsImageRes.failure){
            dispatch(raiseToast({ severity: 'error', detail: processingMaterialsImageRes.data.error, life: 3000 }))
        }else{
            let processedImagesData = []
            if (processingMaterialsImageRes.data.image_data) {
                processedImagesData = processingMaterialsImageRes.data.image_data
            }

            if (processImageData.type === "MATERIAL_DETAILS") {
                if (processingMaterialsImageRes.data.long_material_desc) {
                    let newProductDescription = processingMaterialsImageRes.data.long_material_desc
                    if (!prevProductDescription.trim() && productDescription.trim()) {
                        setPrevProductDescription(productDescription)
                        setShowPrevProductDescriptionInput(true)
                    }
                    setProductDescription(newProductDescription)
                }
            }

            if(processedImagesData.length){
                let uniqueMaterialImages = []
                if (processImageData.type !== "MATERIAL_DETAILS") {
                    let relatedMaterialImage = materialImages.find(eachImage => eachImage.dataURI === processedImagesData[0].dataURI)
                    if (relatedMaterialImage) {
                        return dispatch(raiseToast({ severity: 'error', detail: "The uploaded image already added", life: 3000 }))
                    }
                    uniqueMaterialImages = processedImagesData
                } else {
                    const existingImageURIs = new Set(materialImages.map(img => img.dataURI))
                    const newImageURIs = new Set()

                    uniqueMaterialImages = processedImagesData.filter(img => {
                        if (!existingImageURIs.has(img.dataURI) && !newImageURIs.has(img.dataURI)) {
                            newImageURIs.add(img.dataURI)
                            return true
                        }
                        return false
                    })
                }

                const availableSlots = 5 - materialImages.length;
                if (availableSlots > 0) {
                    uniqueMaterialImages = uniqueMaterialImages.slice(0, availableSlots);
                } else {
                    uniqueMaterialImages = []
                }

                let updatedProcessedImagesData = uniqueMaterialImages.map(eachImage => {
                    return {...eachImage, documentName: "MATERIAL_MASTER", imageId: uuid()}
                })

                setMaterialImages(prevState => [...prevState, ...updatedProcessedImagesData])
            }else{
                if(processImageData.type === "MATERIAL_DETAILS"){
                    dispatch(raiseToast({ severity: 'error', detail: "No image found. Please upload or enter image url manually", life: 3000 }))
                }else{
                    dispatch(raiseToast({ severity: 'error', detail: "The image does not have proper resolution. Please select another", life: 3000 }))
                }
            }
            setDisabledAskJaadu(true)
            setImageURL("")
        }
        setVisibleProcessingImages(true)
    }

    const handleCloseProcessImageModal = (productDescriptionType) => {

        if (materialImages.length === 0) {
            return dispatch(raiseToast({ severity: 'error', detail: "Please upload atleast one image", life: 3000 }))
        } else if (materialImages.length && !thumbnailImageId) {
            return dispatch(raiseToast({ severity: 'error', detail: "Please select thumbnail image", life: 3000 }))
        }

        if (!productDescription || !productDescription.trim()) {
            return dispatch(raiseToast({ severity: 'error', detail: "Please enter product description", life: 3000 }))
        }

        if (!productDescriptionType || productDescriptionType === "NEW") {
            let productDescriptionValue = productDescription.trim()
            if (productDescriptionValue) {
                if (productDescriptionValue.length < 100) {
                    return dispatch(raiseToast({ severity: 'error', detail: "Product description must be at least 100 characters long", life: 3000 }))
                } else if (productDescriptionValue.length > 500) {
                    return dispatch(raiseToast({ severity: 'error', detail: "Product description cannot exceed 500 characters", life: 3000 }))
                } else {

                }
            }

            setProductDescription(productDescriptionValue)
        } else {
            setProductDescription(prevProductDescription)
        }

        if(!showProductDescriptionInput){
            setShowProductDescriptionInput(true)
        }

        if(showPrevProductDescriptionInput){
            setShowPrevProductDescriptionInput(false)
        }

        setPrevProductDescription("")
        setVisibleProcessingImages(false)
    }

    return (
        <div className="edit-material-item">
            <TabView>
                <TabPanel header="Material Item">
                    <div className="flex flex-row justify-content-between">
                        <h4 className="mt-0 ml-2 mb-2">Requested Material Id: {materialItemTempObj?.materialId} {materialItemTempObj?.remarks?.toLowerCase().includes('routed') ? "(Routed)" : ""}</h4>
                        <div>
                            <span className="font-bold">Raised By :</span>
                            <span className="ml-2">
                                {getFullName(materialItemTempObj.raisedByUserFirstName, materialItemTempObj.raisedByUserLastName)}
                            </span>
                        </div>
                        <div>
                            <span className="font-bold">Assigned To :</span>
                            <span className="ml-2">{getFullName(materialItemTempObj.assigneeUserFirstName, materialItemTempObj.assigneeUserLastName) || "-"}</span>
                        </div>
                    </div>
                    <div className="p-card">
                        <div className="grid my-1 mx-1">
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                {
                                    relatedCategory ?
                                        <div><span className="font-bold"> Category :</span><span className="ml-2">{relatedCategory.categoryName}</span></div>
                                        :
                                        <div><span className="font-bold"> Category :</span><span>-</span></div>
                                }
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                {
                                    relatedBrand ?
                                        <div><span className="font-bold"> Brand :</span><span className="ml-2">{relatedBrand.brandName}</span></div>
                                        :
                                        <div><span className="font-bold"> Brand :</span><span>-</span></div>
                                }
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                {
                                    materialItemTempObj ?
                                        <div><span className="font-bold"> Product Name :</span><span className="ml-2">{materialItemTempObj.productName}</span></div>
                                        :
                                        <div><span className="font-bold"> Product Name :</span><span >-</span></div>
                                }
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                {
                                    materialItemTempObj ?
                                        <div><span className="font-bold"> Variant :</span><span className="ml-2">{materialItemTempObj.variantName}</span></div>
                                        :
                                        <div><span className="font-bold"> Variant :</span><span className="ml-2">{materialItemTempObj.variantName}</span></div>
                                }
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <div><span className="font-bold">UOM Value :</span><span className="ml-2">{materialItemTempObj.UOMValue} {materialItemTempObj.UOM}</span></div>
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <div><span className="font-bold">Keywords :</span><span className="ml-2">{materialItemTempObj.keywords}</span></div>
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0 text-area">
                                <div><span className="font-bold">Remarks :</span><span className="ml-2">{materialItemTempObj.remarks}</span></div>
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-8 lg:mb-0">
                                <div><span className="font-bold">Product Specification :</span><span className="ml-2">{materialItemTempObj.productSpecification ? materialItemTempObj.productSpecification : '-'}</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row justify-content-between">
                        <h4 className="mt-0 ml-2 mb-2">Material Item</h4>
                        {/*<CheckboxField name="materialItemTemp" label="Use requested material detail" checked={defaultMaterialItemTemp} onChange={(e) => handleSetDefaultMaterialItemTemp(e)} /> */}
                    </div>
                    <div className="p-card">
                        <div className="grid my-2 mx-2">
                            <div className="flex col-12 mb-2 lg:col-3 lg:mb-0">
                                <CheckboxField label="Partial Specs Only" name="partialSpecsOnly" value="partialSpecsOnly" onChange={(e) => handleInputChange(e)} checked={materialItemInterimObj.partialSpecsOnly} />
                            </div>
                        </div>
                        <div className="grid my-2 mx-2">
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <AutoCompleteField name="categoryId" labelText="Category" field="categoryName" placeholder="Search category" value={materialItemInterimObj.categoryId} suggestions={searchedMaterialCategory} searchMethod={searchCategory} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver} onDrop={handleDrop} dropdown forceSelection errorMessage={formErrors.categoryId} required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <AutoCompleteField name="brandId" labelText="Brand" field="brandName" placeholder="Search brand" value={materialItemInterimObj.brandId} suggestions={searchedmaterialBrands} searchMethod={searchBrands} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver} onDrop={handleDrop} dropdown errorMessage={formErrors.brandId} forceSelection loading={isProductsByCaterogyLoading} required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <AutoCompleteField name="productName" labelText="Product name" field="productName" placeholder="Search name" value={materialItemInterimObj.productName} suggestions={searchedProductNames} searchMethod={searchProductNames} onChange={(e) => handleInputChange(e)} onKeyPress={(e) => handleKeyPress(e)} onDragOver={handleDragOver} onDrop={handleDrop} onPaste={(e) => handleCopyPaste(e)} dropdown disabled={!materialItemInterimObj.categoryId} errorMessage={formErrors.productName} loading={isProductsByCaterogyLoading} required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <AutoCompleteField name="variantName" labelText="Variant name" field="variantName" placeholder="Search variant" value={materialItemInterimObj.variantName} suggestions={searchedVariantNames} searchMethod={searchVariantNames} onChange={(e) => handleInputChange(e)} onKeyPress={(e) => handleKeyPress(e)} onPaste={(e) => handleCopyPaste(e)} onDragOver={handleDragOver} onDrop={handleDrop} dropdown forceSelection={materialSpecificationMappedProducts.length > 0 ? true : false} disabled={!materialItemInterimObj.productName} errorMessage={formErrors.variantName} loading={isProductsByCaterogyLoading} onBlur={(event) => onBlurVariantChange(event)} required />
                            </div>
                            {
                                relatedMaterialSpecifications.length > 0 && 
                                <>
                                    {
        
                                        materialItemInterimObj.currentProdSpecification ?
                                            <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                                                <TextInputField name="productSpecification" labelText="Current Product Specification" value={materialItemInterimObj.currentProdSpecification} disabled />
                                            </div>
                                            : ""
                                    }
                                    <div className="flex col-12 mb-12 lg:col-12 lg:mb-0">
                                        <span style={{fontSize:"12px"}}>Product Specification (<span style={{color:"#00baaa"}}>Structured</span>)</span>
                                    </div>
                                    {
                                        relatedMaterialSpecifications.map((specification, index) => {
                                            return (
                                                <div key={index} className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                                    <TextInputField name={specification.attribute} labelText={`${specification.attribute} ( Unit: ${specification.attributeUnit ? specification.attributeUnit : "NA"} )`} value={materialItemInterimObj[specification.attribute]} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver} onDrop={handleDrop} disabled={!materialItemInterimObj.variantName} errorMessage={formErrors[specification.attribute]} required={specification.materialSpecificationMandatoryTypeId === 1} />
                                                </div>
                                            )
                                        })
                                    }
                                </>
                            }
                            {
                                relatedMaterialSpecifications.length === 0 && <div className="flex flex-column col-12 mb-2 lg:col-8 lg:mb-0">
                                    <AutoCompleteField
                                        name="productSpecification"
                                        labelText={
                                            <>
                                                Product Specification
                                                {materialItemInterimObj?.isStructuredProduct && (
                                                    <span>
                                                        (<span style={{ color: "#00baaa" }}>Structured</span>)
                                                    </span>
                                                )}
                                            </>
                                        }
                                        field="productSpecification"
                                        placeholder="Search specification"
                                        value={materialItemInterimObj.productSpecification}
                                        suggestions={searchedMaterialSpecifications}
                                        searchMethod={searchMaterialSpecification}
                                        onChange={(e) => handleInputChange(e)}
                                        // onBlur={(event) => onBlurSpecificationChange(event)}
                                        onDragOver={handleDragOver}
                                        onDrop={handleDrop}
                                        dropdown
                                        disabled={!materialItemInterimObj.variantName || materialItemInterimObj.partialSpecsOnly}
                                        errorMessage={formErrors.productSpecification}
                                        loading={isProductsByCaterogyLoading && !materialItemInterimObj.partialSpecsOnly}
                                        forceSelection={isStructuredMaterialItem}
                                    />
                                </div>
                            }
                            <div className="flex col-3 pl-0 pt-0 lg:col-3 lg:mb-0">
                                <div className="flex flex-column col-12 mb-2 md:col-6 lg:mb-0">
                                    <TextInputField name="UOMValue" labelText="UOM Value" keyfilter={"pnum"} value={materialItemInterimObj.UOMValue} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver} onDrop={handleDrop} errorMessage={formErrors.UOMValue} required />
                                </div>
                                <div className="flex flex-column col-12 mb-2 md:col-6 lg:mb-0">
                                    <AutoCompleteField name="UOM" labelText="UOM" field="UOM" placeholder="UOM" value={materialItemInterimObj.UOM} suggestions={searchedmaterialUOMs} searchMethod={searchUOMs} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver} onDrop={handleDrop} dropdown disabled={isVariantProductUOM && !materialItemInterimObj.partialSpecsOnly} forceSelection errorMessage={formErrors.UOM} required />
                                </div>
                            </div>
                            <div className="flex col-3 pl-0 pt-0 lg:col-9 lg:mb-0">
                                <div className='mt-3 flex col-12 mb-2 md::col-3 lg:mb-0'>
                                    <img
                                        className="gif"
                                        src="https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExM3pnaG10Znc3aWVkcm9lcGt3eXFzbGxtcWY5MzdpYnpmanh6NndjeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5k5vZwRFZR5aZeniqb/giphy.gif"
                                        alt="Jaadu AI"
                                        style={{ width: "35px", height: "35px", borderRadius: "20px" }}
                                    />
                                    <Button className="small-btn ml-1" label="Ask Jadu" onClick={() => handleProcessImageInputType("MATERIAL_DETAILS")} disabled={materialItemObj?.materialId || disabledAskJaadu} />
                                </div>
                            </div>
                        </div>
                        {
                            materialItemObj?.materialId ?
                                <div className="my-2 mx-2" style={{ textAlign: 'right' }}>
                                    <p style={{ color: "#00baaa" }}>Material already exists with material id <span style={{ color: "red" }}>{materialItemObj.materialId}</span></p>
                                </div> : ""
                        }
                        <div className="grid my-2 mx-2">
                            <div className="flex flex-column col-7 pl-0 pt-0">
                                <div className="flex flex-column col-12">
                                    <ChipsField name="keywords" labelText="Keywords" onChange={(e) => handleInputChange(e)} value={materialItemInterimObj.keywords} />
                                </div>
                                <div className="flex flex-column col-12 text-area">
                                    <TextAreaField name="remarks" labelText="Remarks" rows={2} onChange={(e) => handleInputChange(e)} value={materialItemInterimObj.remarks} />
                                </div>
                                {
                                    showProductDescriptionInput && 
                                        <div className="flex flex-column col-12 text-area mb-2">
                                            <TextAreaField name="productDescription" labelText="Product Description" placeholder="Please enter product description" maxLength={500} rows={3} autoResize onChange={(e) => setProductDescription(e.target.value)} value={productDescription} />
                                        </div>
                                }
                            </div>
                            <div className="flex flex-column col-5 align-items-start">
                                { materialImages.length > 0 && <h4 className="mt-0 ml-2 mb-2">Material Images</h4> }
                                <div className='' style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem' }}>
                                    {
                                        materialImages.length > 0 ? materialImages.map(image => {
                                            let isThumbnailImage = image.imageId === thumbnailImageId
                                            return(
                                                <div key={image.imageId} className='prod-image-container'>
                                                    <div className=''>
                                                        <img 
                                                            src={image.dataURI} 
                                                            alt="Preview" 
                                                            className="prod-image" 
                                                            style={{ border: isThumbnailImage ? '2px solid #00baaa' : '1px solid #ccc', boxShadow: isThumbnailImage ? '0 0 10px rgba(0, 255, 0, 0.5)' : 'none', borderRadius: "3px" , objectFit: 'cover'}}
                                                        />
                                                        <i className="pi pi-times prod-remove-icon" onClick={() => handleRemoveMaterialImage(image.imageId)}></i>
                                                    </div>
                                                </div>
                                            )
                                        }) : ""
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-column mt-3 my-2 mx-2' style={{padding:"0.3rem"}}>
                            <h4 className="mb-2" style={{color:'#00baaa'}}>Custom Message: </h4>
                            <div className='flex justify-content-start'>
                                <Button label='Partial Specs' className="small-btn mr-2 custom-message-btn partial-specs-btn" onClick={() => handleCustomMessageType("PARTIAL_SPECS")} />
                                {
                                    relatedMaterialSpecifications.length && !allAttributesValid ?
                                        <Button label='Missing Specs' className="small-btn mr-2 custom-message-btn missing-specs-btn" onClick={() => handleCustomMessageType("MISSING_SPECS")} />
                                        : null
                                }
                                <Button label='Google Chat' className="small-btn custom-message-btn google-chat-btn" onClick={() => handleCustomMessageType("GOOGLE_CHAT")} />
                            </div>
                        </div>
                        <div className='mt-3 flex justify-content-end'>
                            <Button label="Reject" className="mr-3" severity="danger" onClick={() => setVisibleRejectMaterialItem(true)} permissions={[34]} applyThrottle={true} />
                            <Button label="Accept" onClick={() => handleSubmitMaterialItemInterim()} permissions={[34]} applyThrottle={true} />
                        </div>
                        <div className="grid my-2 mx-2"></div>
                        <ConfirmDialog
                            visible={visibleRejectMaterialItem}
                            onHide={() => {
                                setVisibleRejectMaterialItem(false)
                            }}
                            header="Reject due to:"
                            message={
                                <div className="m-0 p-0 px-0">
                                    <TextAreaField
                                        name="rejectionRemarks"
                                        labelText="Remarks"
                                        rows={2}
                                        autoResize
                                        onChange={(e) => setRejectionRemarks(e.target.value)}
                                        value={rejectionRemarks}
                                    />
                                </div>
                            }
                            footer={
                                <div className="ml-2">
                                    <Button
                                        label="Wrong Category"
                                        className="small-btn custom-message-btn reject-custom-btn"
                                        severity="danger"
                                        onClick={() => {
                                            handleCustomMessageType("WRONG_CATEGORY")
                                        }}
                                    />
                                    <Button
                                        label="Kam Request"
                                        className="small-btn custom-message-btn reject-custom-btn"
                                        severity="danger"
                                        onClick={() => {
                                            handleCustomMessageType("KAM_REQUEST")
                                        }}
                                    />
                                </div>
                            }
                            style={{ maxWidth: '25vw' }}
                        />
                    </div>
                </TabPanel>
                {
                    props.isCategoryUser ?
                        <TabPanel header="History">
                            <MaterialMasterInterim
                                materialMasterInterimData={props.materialMasterInterimData}
                                materialCategory={props.materialCategory}
                                materialBrands={props.materialBrands}
                            />
                        </TabPanel> : ""
                }
            </TabView>
            <Dialog header="Material Images" visible={visibleProcessingImages} style={{ width: '65vw', maxHeight: "65%" }} closable={false} >
                <ProcessingImages 
                    handleImageURLChange={handleImageURLChange}
                    handleImageUrl={handleImageUrl}
                    handleUploadMaterialImage={handleUploadMaterialImage}
                    imageURL={imageURL}
                    materialImages={materialImages}
                    setMaterialImages={setMaterialImages}
                    productDescription={productDescription}
                    setProductDescription={setProductDescription}
                    thumbnailImageId={thumbnailImageId}
                    setThumbnailImageId={setThumbnailImageId}
                    isLoaderVisible={isLoaderVisible}
                    handleRemoveMaterialImage={handleRemoveMaterialImage}
                    handleCloseProcessImageModal={handleCloseProcessImageModal}
                    prevProductDescription={prevProductDescription}
                    setPrevProductDescription={setPrevProductDescription}
                />
            </Dialog>
            <Loading visible={isLoaderVisible} />
        </div>
    )

}

export default EditPendingMaterialItem;